import UserProjectList from 'components/UserProjectList/UserProjectList'
import Footer from 'components/shared/Footer/Footer'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import Loader from 'components/shared/Loader/Loader'
import SiteHeader from 'components/shared/SiteHeader/SiteHeader'
import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import { fetchFavourites } from 'redux/actions/FavouriteActions'
import { fetchProgress } from 'redux/actions/ProgressActions'

export const UserProjectListContainer = ({
  dispatch,
  user,
  progress,
  favourites,
  router: { navigate },
  i18n,
  tab,
}) => {
  const [prevTab, setPrevTab] = useState(null)

  const refreshData = useCallback(() => {
    if (user) {
      dispatch(fetchFavourites(i18n.language, user.access_token))
      dispatch(fetchProgress(i18n.language, user.access_token))
    } else {
      navigate('/')
    }
  }, [user, i18n, dispatch, navigate])

  useEffect(() => {
    if (prevTab !== tab) {
      refreshData()
      setPrevTab(tab)
    }
  }, [tab, prevTab, refreshData])

  return (
    <div>
      <HtmlHead title="Projects" />
      <SiteHeader locale={i18n.language} />
      <Loader display={progress.loading} />
      <UserProjectList
        display={!progress.loading && !progress.error}
        locale={i18n.language}
        progress={Object.values(progress.entities)}
        favourites={Object.values(favourites.entities)}
        isInProgress={tab === 'progress'}
        isInFavourites={tab === 'favourites'}
      />
      <Footer
        text="project.footer.feedback.homepage.text"
        userID="progress-list-footer-user-id"
      />
    </div>
  )
}

UserProjectListContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  progress: PropTypes.object.isRequired,
  favourites: PropTypes.object.isRequired,
  user: PropTypes.object,
  router: PropTypes.shape({
    navigate: PropTypes.func.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string.isRequired,
  }).isRequired,
  tab: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  const { progress, favourites, authentication } = state
  return {
    progress,
    favourites,
    user: authentication.user,
  }
}

export default withNamespaces('translations')(
  connect(mapStateToProps)(withRouter(UserProjectListContainer))
)
